import { FC } from 'react';

import { CuttedIconBackground, LogoSelinaWhite } from 'components/icons';
import LogoMark from 'components/icons/LogoMark';
import useViewport from 'helpers/useViewport';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import appRoutes from 'utils/routes';

import {
    BackgroundIcon,
    HalfLogoBackground,
    LogoMarkContainer,
    StyledContainer,
    StyledDiv,
    StyledLogoLink,
} from './Authentication.styles';
import { Login, Register } from './components';

const Authentication: FC = () => {
    const { gteMedium: isDesktop } = useViewport();
    const { search } = useLocation();

    const isRegistrationRoute = useRouteMatch(appRoutes.register.root);

    return (
        <main>
            <StyledContainer>
                {isDesktop && !isRegistrationRoute && <HalfLogoBackground />}
                <StyledDiv>
                    <StyledLogoLink to={appRoutes.home.root + search}>
                        <LogoSelinaWhite />
                        {isRegistrationRoute && (
                            <LogoMarkContainer>
                                <LogoMark />
                            </LogoMarkContainer>
                        )}
                    </StyledLogoLink>
                    <Switch>
                        <Route exact path={appRoutes.login.root}>
                            <Login />
                        </Route>
                        <Route exact path={appRoutes.register.root}>
                            <Register />
                        </Route>
                    </Switch>
                </StyledDiv>
                {!isDesktop && !isRegistrationRoute && (
                    <BackgroundIcon>
                        <CuttedIconBackground />
                    </BackgroundIcon>
                )}
            </StyledContainer>
        </main>
    );
};

export default Authentication;
